import React, { Component } from 'react'
import { checkTranslation, imageAddress, translate } from "../../utils/useful";
import SwitchInput from '../../components/inputs/SwitchInput';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../stores/actionsList';
import ActionButton from '../../components/partials/ActionButton';
import { databasePermissions, messengerPermissions } from '../../variables/permissionsObject';
import CAHeader from '../../components/header/CAHeader';
import ButtonAnimated from '../../components/buttons/ButtonAnimated';
import FixedView from '../../components/FixedView';
import SearchUsersFixedView from './SearchUsersFixedView';
import SearchGroupsFixedView from './SearchGroupsFixedView';
import SidebarView from '../../components/SidebarView';

class UserPrespective extends Component {

    state = {

        actions: {
            edit: { key: "edit", label: "{{lang}}ca.Edit", color: '#677dc4', bgColor: '#677dc4', function: "openEditUser" },
            remove: { key: "remove", label: "{{lang}}ca.Remove", color: '#ee5050', bgColor: '#ee5050', function: "openRemoveModal" },
        },
        category: [
            { title: "none", },
            { title: "form", },
            { title: "page", },
        ],
        tab: [
            { title: "Layout", },
            { title: "Permissions", },
        ],
        layout: [
            { title: "Layout", img: "/images/back/aleksandr-popov-V3snakBbbfY-unsplash.jpg" },
            { title: "Permissions", img: "/images/hub/banner.jpg" },
            { title: "Layout", img: "/images/back/andreas-gucklhorn-mawU2PoJWfU-unsplash.jpg" },
            { title: "Layout", img: "/images/back/fabian-quintero-UWQP2mh5YJI-unsplash.jpg" },
            { title: "Layout", img: "/images/back/red-zeppelin-tB9ennZor-0-unsplash.jpg" },
            { title: "Layout", img: "/images/back/jay-mantri-TFyi0QOx08c-unsplash.jpg" },
            { title: "Layout", img: "/images/back/silvestri-matteo-6-C0VRsagUw-unsplash.jpg" },
            { title: "Layout", img: "/images/back/shifaaz-shamoon-9K9ipjhDdks-unsplash.jpg" },
            { title: "Layout", img: "/images/back/jay-mantri-TFyi0QOx08c-unsplash.jpg" },
            { title: "Layout", img: "/images/back/silvestri-matteo-6-C0VRsagUw-unsplash.jpg" },
            { title: "Layout", img: "/images/back/shifaaz-shamoon-9K9ipjhDdks-unsplash.jpg" },
            { title: "Layout", img: "/images/back/jay-mantri-TFyi0QOx08c-unsplash.jpg" },
            { title: "Layout", img: "/images/back/silvestri-matteo-6-C0VRsagUw-unsplash.jpg" },
            { title: "Layout", img: "/images/back/shifaaz-shamoon-9K9ipjhDdks-unsplash.jpg" },
        ],
        selected: 0,
        currentTab: 0,
        collectionAdmins: [],
        users: [],
        public: true,

        permissionsObject: {
            // postMessage: { key: 'postMessage', label: '{{lang}}ca.Post Message' },
            // editMessageOfOthers: { key: 'editMessageOfOthers', label: '{{lang}}ca.Edit Message Of Others' },
            // deleteMessageOfOthers: { key: 'deleteMessageOfOthers', label: '{{lang}}ca.Delete Message Of Others' },
            // invitUsersViaLink: { key: 'invitUsersViaLink', label: '{{lang}}ca.Invite Users Via Link' },
            // manageVideoChats: { key: 'manageVideoChats', label: '{{lang}}ca.Manage Video Chats' },
            // editApplet: { key: 'editApplet', label: '{{lang}}ca.Edit Applet', },
            // editPermissions: { key: 'editPermissions', label: '{{lang}}ca.Edit Permissions' },
        },
        collection: true,
        hasAdminExceptions: false,
        hasUserExceptions: false,
        adminExceptions: false,
        userExceptions: false,
        searchTab: 'users',
        search: '',

    }

    componentDidMount() {
        this.getPermissions()
        let me = this.props.user?.info
        let users
        let publicStatus
        let owner
        let publicPermissions
        // console.log('this.props.initData', this.props.initData)
        if (this.props.initData?.permissions?.users && this.props.initData?.permissions?.users.length > 0) {
            users = this.props.initData?.permissions?.users
            publicStatus = this.props.initData?.permissions?.public
            owner = this.props.initData?.permissions?.owner
            publicPermissions = this.props.initData.permissions?.publicPermissions
        } else {
            users = []
            publicPermissions = '*'
            publicStatus = true
            owner = me?._id
        }


        this.setState({ users, owner, public: publicStatus, publicPermissions })

        if (this.props.setHeader) {
            // this.props.setHeader("dummy",1)
            this.props.setHeader({
                'toolbar': null,
                'showToolbar': false,
                // 'title': `${this.props.user?.info?.fullname}`,
                isPortal: true, doNotshowNotification: true,
                'title': "Create Applet | Manage Access",
                create: true,
                topHeaderComponent: this.topHeaderComponent,
                backAction: () => this.props.lastStage()
            })
        }

    }

    getPermissions = () => {
        // permissions
        let permissionsObject = {}
        for (let i = 0; i < this.props.initData?.features?.length; i++) {
            switch (this.props.initData.features[i]) {
                case 'Messenger':
                    permissionsObject = messengerPermissions
                    break;
                case 'Database':
                    permissionsObject = databasePermissions
                    break;
                default:
                    break;
            }
        }
        this.setState({ permissionsObject })
    }

    nextStage = () => {
        // let data = {
        //     users: this.state.users,
        //     public: this.state.public,
        // }
        let data = this.props.initData.usersPermissions ?? {}
        data.public = this.state.public
        if (this.state.public) {
            // data.publicPermissions = this.state.publicPermissions
        }
        if (data) {
            console.log('dataaa', data)
            this.props.setData({ usersPermissions: data }, () => {

                if (this.props.continue) {
                    this.props.continue(this.props.stageName)
                } else {
                    this.props.changeStage('info')
                }


            })
        }
    }

    changeValue = (key, value) => {
        this.setState({ [key]: value }, () => {
            if (this.state.public) {
                this.setState({ publicPermissions: '*' })
            }
        })

        // console.log("key, value", key, value)
        // if (this.props.setData) {
        //     this.props.setData({ usersPermissions: '*' }, () => {

        //     })
        // }
    }

    onNewUsersSelected = (searchType, user, type, cb) => {
        let users = this.state.users
        let list = users
        let currentItemIndex = this.state.currentItemIndex
        user.type = type
        list.push({ [type]: user, permissions: '*' })
        currentItemIndex = list.length - 1
        let item = list[currentItemIndex]
        users = list
        this.setState({ users }, () => {
            // this.openPermissions(item, currentItemIndex)
        })
        if (searchType == 'users') {
            this.searchUsersFixedView.hideView()
        }
        if (searchType == 'groups') {
            this.searchGroupsFixedView.hideView()
        }
        cb()
    }

    removePermission = (item, index, type) => {
        if (!item.mainAccess) {
            let list = this.state.users
            list.splice(index, 1)
            this.setState({ users: list })
        } else {
            this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.canNotChange', description: translate("The list which includes the owner can not be removed") })
        }
    }

    openPermissions = (item, index, type) => {
        if (index != null) {
            let listHasOwner = false
            if (item?.hub) {
                if (item.hub.owner == true) {
                    listHasOwner = true
                }
            }

            this.setState({ isMainAccess: item?.mainAccess, currentItem: item, listHasOwner, currentItemIndex: index })
            this.sidebarView.open()
        }
    }

    showPermissionsText = (permissions) => {
        let text = ''

        if (permissions == '*') {
            text = translate("Full Access")
        } else {
            text = Object.values(permissions).length + translate(' Permissions')
            if (Object.values(permissions).length == 0) {
                text = translate("No Permissions, Will be removed")
            }
        }

        return text
    }

    infoView(user, index) {
        return (
            <div className='flexc py-1'>
                <div className='mx-2 flexcc'>
                    {user.type == 'group' ? (
                        <img className='task-check-img' src={'/images/icons/comunities.png'} height={26} width={26} style={{ borderRadius: 20 }} />
                    ) : (
                        <img className='task-check-img' src={imageAddress(user?.image, 'profile')} height={26} width={26} style={{ borderRadius: 20 }} />
                    )}
                </div>
                <div className='flexc flex-1'>
                    <p className='task-title  text-small color-gray-3 cursor-pointer'>{user.fullname ?? user.name}</p>
                    {user.owner && (
                        <div className='mld-2 flexcc px-2 py-1' style={{ backgroundColor: '#eee', borderRadius: 20 }}>
                            <p className='text-smaller color-gray-1'>{translate('ca.Owner')}</p>
                        </div>
                    )}
                </div>
            </div>
        )
    }

    permissionInfoView(user, type, index) {
        return (
            <div className='flexcb mb-1 pb-1' style={{ borderBottom: '1px solid #f6f6f6' }}>
                <div className='flexc'>
                    <div className='mld-2 mrd-3 flexcc'>
                        {user?.type && user.type == 'group' ? (
                            <img className='task-check-img' src={'/images/icons/comunities.png'} height={26} width={26} style={{ borderRadius: 20 }} />
                        ) : (
                            <img className='task-check-img' src={imageAddress(user?.image, 'profile')} height={26} width={26} style={{ borderRadius: 20 }} />
                        )}
                    </div>
                    <div className='d-flex flex-column  flex-1'>
                        <div className='flexc'>
                            <p className='task-title  text-small color-gray-3 '>{user.fullname ?? user.name}</p>
                            {user.owner && (
                                <div className='mld-2 flexcc px-2 py-1' style={{ backgroundColor: '#eee', borderRadius: 20 }}>
                                    <p className='text-smaller color-gray-1'>{translate('ca.Owner')}</p>
                                </div>
                            )}
                        </div>
                        {user.username && (
                            <p className='task-title  text-smaller color-gray-2 '>{user.username}</p>
                        )}
                        {user.type == 'group' && (
                            <p className='task-title  text-smaller color-gray-2 '>{translate('ca.group')}</p>
                        )}
                    </div>
                </div>

                {!user.owner && (
                    <button onClick={() => this.removeUserFromPermission(user, type, index)} className='mx-2  flexcc' style={{ backgroundColor: '#eee', borderRadius: 20, width: 18, height: 18 }}>
                        <img className='opacity-5' src={'/assets/icons/close.svg'} height="14px" />
                    </button>
                )}

            </div>
        )
    }

    changePublicPermission = (key, value, extra) => {
        let publicPermissions = this.state.publicPermissions
        if (publicPermissions == '*') {
            publicPermissions = {}
            for (const [pkey, pvalue] of Object.entries(this.state.permissionsObject)) {
                if (pvalue.subPermissions) {
                    for (const [spkey, spvalue] of Object.entries(pvalue.subPermissions)) {
                        if (!publicPermissions[pkey]) {
                            publicPermissions[pkey] = {}
                        }
                        publicPermissions[pkey][spkey] = true
                    }
                }
                else {
                    publicPermissions[pkey] = true
                }
            }


        }
        if (publicPermissions == null) {
            publicPermissions = {}
        }

        publicPermissions[key] = value
        if (!publicPermissions[key]) {
            delete publicPermissions[key]
        }
        let fullAccess = true
        let permissionsLength = 0
        Object.values(publicPermissions).forEach((element) => {
            if (Object.values(element)) {
                permissionsLength += Object.values(element).length
            }
            else {
                permissionsLength += 1
            }
            if (element != '*') {
                fullAccess = false
            }
        })
        let permissionsObjectLength = 0
        Object.values(this.state.permissionsObject).forEach((element) => {
            if (element.subPermissions) {

                permissionsObjectLength += Object.values(element.subPermissions).length
            }
            else {
                permissionsObjectLength += 1

            }
        })
        if (permissionsLength == permissionsObjectLength || fullAccess) {
            publicPermissions = '*'
        }
        // if (Object.keys(this.state.permissionsObject).length == Object.keys(permissions).length) {
        //     permissions = '*'
        // } 

        this.setState({ publicPermissions })


    }

    removeUserFromPermission = (user, type, index) => {
        let users = this.state.users
        let list = users
        // let list = this.state.admins[this.state.currentType]
        // console.log(type)
        // console.log(list[this.state.currentItemIndex])
        list[this.state.currentItemIndex][type].splice(index, 1)
        users = list
        this.setState({ users })
    }

    handlePublicCheckBox = (type, subpermission) => {
        let publicPermissions = this.state.publicPermissions
        let permissionsObject = this.state.permissionsObject

        if (publicPermissions == '*') {
            publicPermissions = {}
            for (const [pkey, pvalue] of Object.entries(permissionsObject)) {
                console.log('pvalue', pvalue)
                publicPermissions[pkey] = '*'

            }
            // console.log('permissionsObject', permissions)
            // list[userIndex].permissions = permissionsObject

        }
        if (publicPermissions[type] == '*') {
            publicPermissions[type] = {}
            for (let i = 0; i < Object.keys(permissionsObject[type].subPermissions).length; i++) {
                publicPermissions[type][Object.keys(permissionsObject[type].subPermissions)[i]] = true
            }
        }
        if (publicPermissions == null) {
            publicPermissions = {}
        }
        if (typeof publicPermissions[type] != 'object') {
            publicPermissions[type] = {}
        }
        if (publicPermissions[type][subpermission]) {
            console.log('subpermission', subpermission)
            if (subpermission == 'view') {
                delete publicPermissions[type].create
                delete publicPermissions[type].delete
                delete publicPermissions[type].edit
            }
            delete publicPermissions[type][subpermission]
        }
        else {
            if (subpermission != 'view') {
                publicPermissions[type].view = true
            }
            console.log('permissions[type]', publicPermissions[type])
            publicPermissions[type][subpermission] = true
        }
        if (Object.values(permissionsObject[type].subPermissions).length == Object.values(publicPermissions[type]).length) {
            publicPermissions[type] = '*'
        }

        let permissionsLength = 0
        let fullAccess = true
        Object.values(publicPermissions).forEach((element) => {
            if (Object.values(element)) {
                permissionsLength += Object.values(element).length
            }
            else {
                permissionsLength += 1
            }
            if (element != '*') {
                fullAccess = false
            }
        })
        let permissionsObjectLength = 0
        Object.values(permissionsObject).forEach((element) => {
            if (element.subPermissions) {

                permissionsObjectLength += Object.values(element.subPermissions).length
            }
            else {
                permissionsObjectLength += 1

            }
        })
        if (permissionsLength == permissionsObjectLength || fullAccess) {
            publicPermissions = '*'
        }
        console.log('finalpermission', publicPermissions)
        this.setState({ publicPermissions })
    }

    handleCheckBox = (sectionKey, permissionKey, subpermission, userIndex) => {
        if (this.state.listHasOwner && this.state.isMainAccess) {
            this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.canNotChange', description: "The list which includes the owner should have full access" })
            return
        }
        let users = this.state.users
        let list = users
        let user = list[userIndex]
        let permissions = user.permissions
        let permissionsObject = this.state.permissionsObject
        if (sectionKey == 'fields') {
            if (permissions == '*') {
                permissions = {}
                for (const [skey, svalue] of Object.entries(permissionsObject)) {
                    permissions[skey] = '*'
                }
                permissions[sectionKey] = '*'
            }
            else {
                permissions[sectionKey] = '*'
            }
            if (permissions == null) {
                permissions = {}
            }
            if (permissions[sectionKey] == '*') {
                permissions[sectionKey] = {}
                permissions[sectionKey][permissionKey] = '*'
                permissions[sectionKey][permissionKey] = '*'
            }
            if (permissions[sectionKey] && permissions[sectionKey][permissionKey] == '*') {
                permissions[sectionKey][permissionKey] = {}
                permissions[sectionKey][permissionKey].view = true
                permissions[sectionKey][permissionKey].edit = true
            }
            delete permissions[sectionKey][permissionKey][subpermission]
            if (permissions[sectionKey][permissionKey]?.length == 2) {
                permissions[sectionKey][permissionKey] = '*'
            }
            let fullAccess = true
            Object.values(permissions).forEach((element) => {
                if (element != '*') {
                    fullAccess = false
                }
            })
            list[this.state.currentItemIndex].permissions = permissions
            users = list
            this.setState({ users })
        }
        else {
            if (permissions == '*') {
                permissions = {}
                for (const [skey, svalue] of Object.entries(permissionsObject)) {
                    permissions[skey] = '*'
                }
                permissions.fields = user.permissions.fields ?? '*'
            }
            if (permissions == null) {
                permissions = {}
            }
            if (permissions[sectionKey] == '*') {
                permissions[sectionKey] = {}
                Object.values(permissionsObject[sectionKey].permissions).forEach((element) => {
                    if (element.subPermissions) {
                        permissions[sectionKey][element.key] = '*'
                    }
                    else {
                        permissions[sectionKey][element.key] = true
                    }
                })
                if (permissions[sectionKey] && permissions[sectionKey][permissionKey]) {
                    if (!user.exception && permissionKey == 'view') {
                        delete permissions[sectionKey].edit
                    }
                    delete permissions[sectionKey][permissionKey]
                }
            }
            if (permissions[sectionKey] && permissions[sectionKey][permissionKey] == '*') {
                permissions[sectionKey][permissionKey] = {}
                for (let i = 0; i < Object.keys(permissionsObject[sectionKey].permissions[permissionKey].subPermissions).length; i++) {
                    permissions[sectionKey][permissionKey][Object.keys(permissionsObject[sectionKey].permissions[permissionKey].subPermissions)[i]] = true
                }
            }
            if (permissions[sectionKey] && permissions[sectionKey][permissionKey] && permissions[sectionKey][permissionKey][subpermission]) {
                if (!user.exception && subpermission == 'view') {
                    delete permissions[sectionKey][permissionKey].create
                    delete permissions[sectionKey][permissionKey].delete
                    delete permissions[sectionKey][permissionKey].edit
                }
                delete permissions[sectionKey][permissionKey][subpermission]
            }
            else {
                if (!user.exception && subpermission != 'view') {
                    if (!permissions[sectionKey]) {
                        permissions[sectionKey] = {}
                    }
                    if (!permissions[sectionKey][permissionKey]) {
                        permissions[sectionKey][permissionKey] = {}
                    }
                    permissions[sectionKey][permissionKey].view = true
                }
                if (!permissions[sectionKey]) {
                    permissions[sectionKey] = {}
                }
                if (!permissions[sectionKey][permissionKey]) {
                    permissions[sectionKey][permissionKey] = {}
                }
                permissions[sectionKey][permissionKey][subpermission] = true
            }
            if (Object.values(permissionsObject[sectionKey].permissions[permissionKey]?.subPermissions)?.length == Object.values(permissions[sectionKey][permissionKey])?.length) {
                permissions[sectionKey][permissionKey] = '*'
            }
            let fullAccess = true
            Object.values(permissions).forEach((element) => {
                if (element != '*') {
                    fullAccess = false
                }
            })
            if ((Object.values(permissions).length == Object.values(this.state.permissionsObject).length && fullAccess)) {
                permissions = '*'
            }
            list[this.state.currentItemIndex].permissions = permissions
            users = list
            this.setState({ users })
        }
    }

    setHeader = (key, value) => {
        if (this.header) {
            if (typeof key == 'object') {
                let object = {
                    showSettings: true,
                    showFrames: 'static',
                }
                for (const [okey, ovalue] of Object.entries(key)) {
                    object[okey] = ovalue
                }
                this.setState({ headerConfig: object }, () => {
                    this.header.forceUpdate()
                })
            }
            else {
                this.setState({ headerConfig: { ...this.state.headerConfig, [key]: value } }, () => {
                    this.header.forceUpdate()
                })
            }
        }
    }

    setData = (key, value, reference, cb) => {
        if (reference == 'PermissionsPage') {
            this.setState({ [key]: value }, () => {
                if (cb) {
                    cb()
                }
            })
        }
        else {
            if (this.props.setData) {
                this.props.setData(key, value, reference, () => {

                })
            }
        }
    }

    topHeaderComponent = () => {
        return (
            <div className='flexc'>

                <ButtonAnimated
                    iconwidth='24px'
                    onClick={this.nextStage}
                    isLoading={this.state.isLoading}
                    title={translate("ca.Continue")}
                    icon='/assets/icons/angle-right-white2.svg'
                    textColor={'#222'}
                    invert={!this.props.colors?.iconInvert}
                    bg={this.props.colors?.iconInvert ? '#000' : '#fff'}
                />
            </div>

        )
    }

    setSearchTab = (tab) => {
        this.setState({ searchTab: tab })
    }

    changeSearchValue = (event) => {
        this.setState({ search: event.target.value }, () => {

        })
    }

    openFixedView = (tab) => {
        let groups = []
        let hubs = []
        this.state.users.forEach(user => {
            if (user?.group)
                groups.push(user?.group)
            if (user?.hub)
                hubs.push(user?.hub)

        });
        this.setState({ hubsInitData: hubs, groupsInitData: groups })
        if (tab == 'users') {
            setTimeout(() => {
                this.searchUsersFixedView.showView()
            }, 50);
        }
        if (tab == 'groups') {
            setTimeout(() => {
                this.searchGroupsFixedView.showView()
            }, 50);
        }
    }


    setUserPermissions = () => {
        let variables = this.props.variables
        if (!variables) {
            variables = {}
        }
        let hub = this.props.initData?.hub
        variables.hub = hub
        variables.targetId = hub
        let searchTab = this.state.searchTab
        return (
            <div className='mt-5 ' style={{}}>
                <div className='d-flex' style={{ width: "max-content" }}>
                    {this.state.tab.map((item, index) => {
                        return (
                            <p className='text-center cursor-pointer py-2 mrd-2 weight-500 font-size-14' onClick={() => this.setState({ currentTab: index })} style={{ color: "#fff", boxShadow: index == this.state.currentTab ? "rgb(0 1 111 / 10%) 1px 2px 6px -1px, rgb(0 15 169 / 6%) 0px 2px 4px -1px" : "", width: 115, borderRadius: 50, background: index == this.state.currentTab ? "#275dff" : "#d2d2d2", }}>{item.title}</p>
                        )
                    })}
                </div>
                {/* layout tab */}
                {this.state.currentTab == 0 && (
                    <div className='mt-3'>
                        <div className='flexc h-100' style={{ flexWrap: 'wrap', }}>
                            {this.state.layout.map((item, index) => {
                                return (
                                    <div className='mrd-3 mb-3' style={{}}>
                                        <img className='br-10' style={{ width: 170, height: 100, }} src={item.img} />
                                        <div className='' style={{}}>
                                            <p className='px-2 py-1 font-size-12 weight-600' style={{ color: "#222" }}>{item.title}</p>
                                        </div>
                                    </div>

                                )
                            })}
                        </div>
                    </div>
                )}
                {/* permission */}
                {this.state.currentTab == 1 && (
                    <div className='mt-3'>
                        <div className='h-100 '>

                            <div className=" w-100 h-100 scroll-no-scrollbar position-relative flex-column" style={{ backgroundColor: '', }}>
                                <div >
                                    <p className="mt-1 text-small color-dark-blue-1 " >{translate('ca.Who can have access to this applet? Admin access and users access')}</p>
                                </div>
                                <div className='mt-3 postition-relative'>
                                    <div className='flexcb mt-1'>
                                        <p className='color-dark-blue-1 text-small text-semibold' >{translate('ca.Public')}</p>
                                        <SwitchInput data={this.state.public} header={{ key: 'public', information: {} }} changeValue={this.changeValue} />
                                    </div>
                                    {/* <UserPermission initData={this.props.initData} language={this.props.settings?.language} setData={this.setData} width={this.props.width} changeStage={this.props.changeStage} lastStage={this.props.lastStage} colors={this.props.colors} /> */}
                                    {!this.state.public && (
                                        <div className='pt-2 pb-3' style={{}}>
                                            <p className='text-small color-dark-blue-1 opacity-5'>{translate('ca.This-applet-will-be-accessable2')}</p>
                                        </div>
                                    )}
                                    {!this.state.public && (
                                        <>
                                            <div className='pb-1 mb-1 flexc'>
                                                <div className='' style={{ width: 250 }}>
                                                    <div className='flexcb permission-btn br-20 p-1' style={{}}>
                                                        <button onClick={() => this.setSearchTab('users')} className={' mrd-2 br-20 w-50 ' + (searchTab == 'users' ? ' permission-select-btn ' : ' permission-notselect-btn ')}>
                                                            <p className={"px-3 py-2 flexcc weight-600 text-small "}>Users</p>
                                                        </button>
                                                        <button onClick={() => this.setSearchTab('groups')} className={' mld-2 br-20 w-50 ' + (searchTab == 'groups' ? ' permission-select-btn ' : ' permission-notselect-btn ')}>
                                                            <p className={"px-3 py-2 flexcc weight-600 text-small "}>Groups</p>
                                                        </button>
                                                    </div>
                                                    <div className='navbarSearch3 my-2 w-100 py-2 px-3 br-100' ref={searchTab == 'users' ? (ref => this.searchUsersNode = ref) : (ref => this.searchGroupsNode = ref)} >
                                                        <div className='d-flex flexcb' onClick={() => { this.openFixedView(searchTab) }} >
                                                            <input className="w-100" onChange={e => this.changeSearchValue(e)} value={this.state.search} type="text" placeholder={translate(`Search in ${searchTab}`)} style={{ backgroundColor: 'transparent', }} />
                                                            <img className='' width={25} src="/assets/icons/search-gray.svg" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='mt-1 mb-3 w-100 bg-white '>
                                                {this.state.users?.map((item, index) => {
                                                    if (!item.exception) {
                                                        return (
                                                            <div className={'w-100 task-row' + (item.done ? ' done ' : '')} key={index}>
                                                                <div className='flexcb w-100 py-2  mb-1 ' style={{ borderBottom: '1px solid #EFF0F1' }}>
                                                                    <div className='flexc '>
                                                                        <ActionButton>
                                                                            <div className=" mt-2 mld-3 py-3 px-3 d-flex flex-column w-100" style={{ minWidth: 120, boxShadow: '0px 0px 30px #10101030', backgroundColor: '#fff', borderRadius: 6 }}>
                                                                                <button onClick={() => this.openPermissions(item, index, 'users')} className="w-100 p-0 text-start flexcb mt-1" >
                                                                                    <p className="text-small  ">{translate('ca.Edit')}</p>
                                                                                    <img src='/assets/icons/useful/text.svg' height={15} />
                                                                                </button>
                                                                                <button onClick={() => this.removePermission(item, index, 'users')} className="w-100 p-0 mt-1 text-start flexcb" >
                                                                                    <p className="text-small ">{translate('ca.Remove')}</p>
                                                                                    <img src='/assets/icons/useful/trash-o.svg' height={15} />
                                                                                </button>
                                                                            </div>
                                                                        </ActionButton>
                                                                        <div onClick={() => this.openPermissions(item, index)} className='flexc task-info w-100 cursor-pointer flex-wrap'>
                                                                            {item?.hub &&
                                                                                this.infoView(item?.hub)
                                                                            }
                                                                            {item?.group &&
                                                                                this.infoView(item?.group)
                                                                            }
                                                                            {(!item.hub) && (!item.group) && (
                                                                                <div>
                                                                                    <p className='color-gray-2 text-small px-2'>{translate('ca.No access is added. This permission will be removed')}</p>
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                    <div className='flexc'>
                                                                        <div onClick={() => this.openPermissions(item, index)} className='cursor-pointer mx-2'>
                                                                            <div className='py-1 px-2  task-priority' style={{ backgroundColor: item.permissions == '*' ? '#FEE9EE' : "#eee", color: item.permissions == '*' ? '#CA5C72' : '#777', borderRadius: 4 }}>
                                                                                <p className=' text-smallest no-wrap'>{checkTranslation(this.showPermissionsText(item.permissions))}</p>
                                                                            </div>
                                                                        </div>
                                                                        <button className='flexcc mld-2' onClick={() => this.openPermissions(item, index)}>
                                                                            <img src='/assets/icons/shield.svg' className='flexcc opacity-5' width={28} />
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )
                                                    }
                                                })}
                                            </div>
                                        </>
                                    )}
                                </div >
                            </div >
                        </div >
                    </div>
                )}
                <FixedView width={this.props.width} zIndex={10} ref={el => this.searchUsersFixedView = el} nodeRef={this.searchUsersNode} xOffset={this.props.language == 'fa' ? 195 : -10} topOffset={0} maxWidth={250} >
                    <SearchUsersFixedView actions={this.props.actions} hubsInitData={this.state.hubsInitData} data={this.state.search} mainAccess={this.state.isMainAccess} onDone={this.onNewUsersSelected} variables={variables} language={this.props.language} />
                </FixedView>
                <FixedView width={this.props.width} zIndex={10} ref={el => this.searchGroupsFixedView = el} nodeRef={this.searchGroupsNode} xOffset={this.props.language == 'fa' ? 195 : -10} topOffset={0} maxWidth={250} >
                    <SearchGroupsFixedView actions={this.props.actions} groupsInitData={this.state.groupsInitData} mainAccess={this.state.isMainAccess} ref={el => this.searchGroupsModal = el} onDone={this.onNewUsersSelected} variables={variables} language={this.props.language} />
                </FixedView>
            </div>
        )
    }

    render() {

        let variables = this.props.variables
        if (!variables) {
            variables = {}
        }
        let hub = this.props.initData?.hub
        variables.hub = hub
        variables.targetId = hub

        return (
            <div className='h-100 w-100 scroll-no-scrollbar overflow-hidden' style={{ position: 'relative', borderBottomRightRadius: '10px' }}>
                <div className='w-100 h-100 position-absolute overflow-hidden' >
                    <div style={{ height: 1500, width: 1500, zIndex: 0, position: 'absolute', top: -50, left: -50, background: 'radial-gradient(67.22% 50% at 50% 50%, rgba(51, 231, 255, 0.15) 0%, rgba(245, 228, 255, 0) 100%)' }}></div>
                    <div style={{ height: 1500, width: 1500, zIndex: 0, position: 'absolute', top: -100, left: "50%", background: 'radial-gradient(48.02% 35.72% at 50% 50%, rgba(50, 247, 51, 0.15) 0%, rgba(128, 255, 0, 0) 100%)' }}></div>
                </div>
                {/* <div className='w-100' style={{ position: 'sticky', top: 0, zIndex: 5 }}>
                    <CAHeader ref={el => this.header = el} config={this.state.headerConfig} toolbar={this.state.toolbar} showToolbar={this.state.showToolbar} type={'static'} functionsHandler={this.functionsHandler} page={this.state.page} language={this.props.language} toolbarView={'applet'} headertype={'applet'} headers={this.state.headers} goToHub={this.props.goToHub} backStage={this.backStage} sections={this.state.sections} modules={this.state.modules} changePage={this.changePage} backbtn={this.state.showBackBtn} applet={this.props.applet} width={this.props.width} colors={this.props.colors} features={this.props.applet?.features} />
                </div> */}
                <div className='w-100 h-100 flexcc' style={{ alignItems: 'flex-start' }}>
                    <div className='w-100 h-100  position-relative' style={{ maxWidth: 650, }}>
                        <div className='w-100 px-3 pt-3 h-100 scroll-no-scrollbar'>

                            {/* <div >
                                <p className="mt-1 text-small color-dark-blue-1 " >{translate('ca.Who can have access to this applet? Admin access and users access')}</p>
                            </div> */}
                            <div className='w-100 flexcb task-row mb-2 px-2 py-2 bg-white mt-4'>
                                <p className='color-blue-1 text-normal'>{translate("Public")}</p>
                                <SwitchInput data={this.state.public} header={{ key: 'public', information: { size: 'small', } }} changeValue={this.changeValue} />

                            </div>
                            <div className='d-flex mt-4'>
                                {this.state.category.map((item, index) => {
                                    return (

                                        <div className='mrd-5 cursor-pointer' key={index} onClick={() => this.setState({ selected: index })} style={{}}>
                                            <div className='br-10 position-relative' style={{ border: index == this.state.selected ? "2px solid #7094ff" : "2px solid #bcbcbc", width: 105, height: 75, overflow: 'hidden' }}>
                                                {index == 1 && (
                                                    <div className=' h-50' style={{ background: "#efefef", width: 105, borderRadius: '8px 8px 0 0 ' }}></div>
                                                )}
                                                {index == 2 && (
                                                    <div className=' h-100' style={{ background: "#efefef", width: 105, borderRadius: 8 }}></div>
                                                )}
                                                {index == this.state.selected && (
                                                    <div className='position-absolute flexcc' style={{ top: "31%", right: "37%", background: "rgb(112, 148, 255)", borderRadius: "50%" }}>
                                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="#fff" style={{ width: 28, height: 28 }}>
                                                            <path stroke-linecap="round" stroke-linejoin="round" d="M9 12.75L11.25 15 15 9.75M21 12c0 1.268-.63 2.39-1.593 3.068a3.745 3.745 0 01-1.043 3.296 3.745 3.745 0 01-3.296 1.043A3.745 3.745 0 0112 21c-1.268 0-2.39-.63-3.068-1.593a3.746 3.746 0 01-3.296-1.043 3.745 3.745 0 01-1.043-3.296A3.745 3.745 0 013 12c0-1.268.63-2.39 1.593-3.068a3.745 3.745 0 011.043-3.296 3.746 3.746 0 013.296-1.043A3.746 3.746 0 0112 3c1.268 0 2.39.63 3.068 1.593a3.746 3.746 0 013.296 1.043 3.746 3.746 0 011.043 3.296A3.745 3.745 0 0121 12z" />
                                                        </svg>

                                                    </div>
                                                )}
                                            </div>
                                            <p className='flexcc' style={{ color: index == this.state.selected ? "#222" : "gray" }}>{item.title}</p>
                                        </div>
                                    )
                                })}

                            </div>

                            <div>
                                {this.state.selected == 1 && (
                                    this.setUserPermissions()
                                )}
                            </div>
                            <div>
                                {this.state.selected == 2 && (
                                    this.setUserPermissions()

                                )}
                            </div>
                        </div>
                    </div>
                </div>
                <SidebarView width={this.props.width} ref={el => this.sidebarView = el} hideOverlay={false} widthCondition={{ xs: '80%', md: '300px' }}>
                    {(this.state.currentItemIndex != null) && (
                        <div className='px-2 pt-3 h-100 scroll-no-scrollbar pb-5'>
                            <div className='flexcb px-2 '>
                                <p className='text-semibold mb-1'>{translate("ca.Admin Access")}</p>
                            </div>
                            <div className='mt-2 d-flex flex-column flex-wrap'>
                                {this.state.currentItemIndex != null && this.state.users && this.state.users[this.state.currentItemIndex]?.hub &&
                                    this.permissionInfoView(this.state.users[this.state.currentItemIndex]?.hub, 'hubs')
                                }
                                {this.state.currentItemIndex != null && this.state.users && this.state.users[this.state.currentItemIndex]?.group &&
                                    this.permissionInfoView(this.state.users[this.state.currentItemIndex]?.group, 'groups')
                                }
                            </div>
                            <div className='mt-3 px-2'>
                                <p className='text-semibold mb-1'>{translate("ca.Permissions")}</p>
                                {this.state.permissionsObject && Object.values(this.state.permissionsObject).map((sectionPermission, index) => {
                                    return (
                                        <div>
                                            <div>
                                                <p>{checkTranslation(sectionPermission.label)}</p>
                                            </div>
                                            {Object.values(sectionPermission.permissions).map((permission) => {
                                                let hasPermission = false
                                                let thisPermission = this.state.users[this.state.currentItemIndex]?.permissions
                                                if (thisPermission == '*') {
                                                    hasPermission = true
                                                }
                                                if (thisPermission && typeof thisPermission[sectionPermission.key] == 'object') {
                                                    hasPermission = thisPermission[sectionPermission.key][permission.key]
                                                }
                                                return (
                                                    <div className='flexcb pt-2 pb-2 px-2 ' style={{ borderBottom: '1px solid #f6f6f6' }}>
                                                        {permission.subPermissions ?
                                                            (<>
                                                                <div className='w-100'>
                                                                    <p>{checkTranslation(permission.label)}</p>
                                                                    {Object.values(permission.subPermissions).map((element) => {
                                                                        hasPermission = false
                                                                        if (thisPermission == '*') {
                                                                            hasPermission = true
                                                                        }
                                                                        else if (thisPermission && thisPermission[sectionPermission.key] == '*') {
                                                                            hasPermission = true
                                                                        }
                                                                        else {
                                                                            hasPermission = ((thisPermission && thisPermission[sectionPermission.key] && thisPermission[sectionPermission.key][permission.key] && thisPermission[sectionPermission.key][permission.key][element.key])
                                                                                || (thisPermission && thisPermission[sectionPermission.key] && thisPermission[sectionPermission.key][permission.key] == '*')) ? true : false
                                                                        }
                                                                        return (
                                                                            <div className='flexcb pld-2'>
                                                                                <p>{checkTranslation(element.title)}</p>
                                                                                <input type={'checkbox'} checked={hasPermission} onChange={() => this.handleCheckBox(sectionPermission.key, permission.key, element.key, this.state.currentItemIndex)} />
                                                                            </div>
                                                                        )
                                                                    })}
                                                                </div>
                                                            </>
                                                            ) : (
                                                                <>
                                                                    <p className='text-small color-gray-1'>{checkTranslation(permission.label)}</p>
                                                                    <SwitchInput data={hasPermission} header={{ key: permission.key, information: { size: 'small', } }} changeValue={this.changePermission} extra={{ type: 'user', index: this.state.currentItemIndex, sectionKey: sectionPermission.key }} />
                                                                </>
                                                            )
                                                        }
                                                    </div>
                                                )
                                            })}
                                        </div>
                                    )
                                })}
                            </div>
                        </div >
                    )}
                </SidebarView>
            </div >
        )
    }
}


const mapStateToProps = state => ({ settings: state.settings, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(UserPrespective);
